import { FormattedMessage } from "react-intl";
import { matchModeLabelId, resolveMatchMode } from "./match-mode";

// The mode's name, as the eyebrow of a match card in a list. Takes the raw column value (the
// wire's string, null for a pre-#159 match) and resolves it here, so both list surfaces name the
// mode the same way. Renders nothing for a mode this build cannot name: the
// `match.workflow.mode${…}` template this replaced ended in "Optimize", so an unknown token
// labelled itself as an Optimize match on the Match list and on the home dashboard.
export function MatchModeLabel({ mode }: { mode: string | null | undefined }) {
  const labelId = matchModeLabelId(resolveMatchMode(mode));
  if (labelId === null) return null;
  return <FormattedMessage id={labelId} />;
}
